"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _editIcon = _interopRequireDefault(require("../../assets/svg/edit-icon.svg"));
var _styled = require("./styled");
var _excluded = ["onClick", "title", "noBlock", "color", "isEdit", "show"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var BlockEdit = function BlockEdit(_ref) {
  var onClick = _ref.onClick,
    title = _ref.title,
    noBlock = _ref.noBlock,
    color = _ref.color,
    isEdit = _ref.isEdit,
    show = _ref.show,
    props = _objectWithoutProperties(_ref, _excluded);
  return (isEdit || !!show) && /*#__PURE__*/_react.default.createElement(_styled.Container, null, isEdit && /*#__PURE__*/_react.default.createElement(_styled.EditButton, {
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _editIcon.default,
    alt: "edit"
  })), /*#__PURE__*/_react.default.createElement(_styled.ContentWrapper, {
    isEdit: isEdit
  }, noBlock ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(_styled.Title, {
    color: color
  }, title), /*#__PURE__*/_react.default.createElement(_styled.TextBlock, null, props.children)) : /*#__PURE__*/_react.default.createElement(_styled.TextBlock, null, title && /*#__PURE__*/_react.default.createElement(_styled.Title, {
    color: color
  }, title), props.children)));
};
BlockEdit.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  title: _propTypes.default.string,
  color: _propTypes.default.string,
  noBlock: _propTypes.default.bool,
  isEdit: _propTypes.default.bool,
  show: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number])
};
BlockEdit.defaultProps = {
  title: '',
  noBlock: false,
  color: null,
  isEdit: true,
  show: true
};
var _default = BlockEdit;
exports.default = _default;